<h2 class="title">*tipos de demandas</h2>

<div [formGroup]="typesForm">
  <div #ocurrenceTypes class="occurence-types">
    <mat-checkbox
      *ngFor="let type of occurrenceTypes"
      name="{{type.name}}"
      id="{{type.id}}"
      (change)="onChange($event)"
      name="types"
      [checked]="type.checked"
      disabled="{{type.disabled}}"
      [disabled]="isVisualization"
      [matTooltip]="type.disabled ? type.messageDisable : ''"
      matTooltipClass="mat-tooltip-mat-checkbox"
    >
      {{ type.name }}
    </mat-checkbox>
  </div>
</div> 
<div class="error-message">
  <br />
  <mat-error
    class="default-error-message"
    *ngIf="[ngForm.submitted] &&
      typesForm.controls.typesListControl.errors?.validateMinSelected &&
      !isVisualization && typesSelectedList.length === 0"
  >
    Campo obrigatório.
  </mat-error>
</div>